/**
 * Certificate / Course Template Config
 * -------------------------------------
 * Used by AchievementPosterTab to render course-aware achievement posters.
 *
 * To add a new exam, just append a new entry below — NO code changes needed
 * elsewhere. The Achievement Poster generator picks color/branding from this.
 *
 * Field reference:
 *   - fullName: Long official name shown on poster
 *   - shortName: Display label (defaults to key)
 *   - code: Exam code (EX200, CKA-001 etc.)
 *   - vendor: Issuing org
 *   - color: Primary brand color (hex)
 *   - accent: Optional secondary color
 *   - tagline: Optional motivational line under course name
 */
export const CERTIFICATE_TEMPLATES = {
  RHCSA: {
    fullName: 'Red Hat Certified System Administrator',
    shortName: 'RHCSA',
    code: 'EX200',
    vendor: 'Red Hat',
    color: '#EE0000',
    accent: '#000000',
    tagline: 'Linux Sysadmin · Industry Standard'
  },
  RHCE: {
    fullName: 'Red Hat Certified Engineer',
    shortName: 'RHCE',
    code: 'EX294',
    vendor: 'Red Hat',
    color: '#EE0000',
    accent: '#1a1a1a',
    tagline: 'Ansible Automation · Enterprise Linux'
  },
  DO188: {
    fullName: 'Red Hat Specialist · Containers & OpenShift',
    shortName: 'DO188',
    code: 'EX188',
    vendor: 'Red Hat',
    color: '#EE0000',
    accent: '#0066CC',
    tagline: 'Containers · Podman · OpenShift Basics'
  },
  RHCOA: {
    fullName: 'Red Hat Certified OpenShift Administrator',
    shortName: 'RHCOA',
    code: 'EX280',
    vendor: 'Red Hat',
    color: '#EE0000',
    accent: '#0066CC',
    tagline: 'OpenShift Cluster Ops · Kubernetes PaaS'
  },
  DO288: {
    fullName: 'Red Hat OpenShift Application Development',
    shortName: 'DO288',
    code: 'EX288',
    vendor: 'Red Hat',
    color: '#0066CC',
    accent: '#EE0000',
    tagline: 'OpenShift App Dev · Cloud-Native'
  },
  EX407: {
    fullName: 'Red Hat Ansible Automation Specialist',
    shortName: 'EX407',
    code: 'EX407',
    vendor: 'Red Hat',
    color: '#EE0000',
    accent: '#444444',
    tagline: 'Ansible Tower · Automation at Scale'
  },
  CKA: {
    fullName: 'Certified Kubernetes Administrator',
    shortName: 'CKA',
    code: 'CKA',
    vendor: 'Linux Foundation · CNCF',
    color: '#326CE5',
    accent: '#0F1B3D',
    tagline: 'Kubernetes Cluster Operations'
  },
  CKAD: {
    fullName: 'Certified Kubernetes Application Developer',
    shortName: 'CKAD',
    code: 'CKAD',
    vendor: 'Linux Foundation · CNCF',
    color: '#326CE5',
    accent: '#0F1B3D',
    tagline: 'Cloud-Native App Development'
  },
  AWS_SAA: {
    fullName: 'AWS Certified Solutions Architect — Associate',
    shortName: 'AWS SAA-C03',
    code: 'SAA-C03',
    vendor: 'Amazon Web Services',
    color: '#FF9900',
    accent: '#232F3E',
    tagline: 'Cloud Architecture · AWS'
  },
  TERRAFORM_ASSOC: {
    fullName: 'HashiCorp Terraform Associate',
    shortName: 'Terraform Associate',
    code: '003',
    vendor: 'HashiCorp',
    color: '#7B42BC',
    accent: '#1A1A1A',
    tagline: 'Infrastructure as Code'
  },
  DOCKER_DCA: {
    fullName: 'Docker Certified Associate',
    shortName: 'Docker DCA',
    code: 'DCA',
    vendor: 'Docker Inc.',
    color: '#2496ED',
    accent: '#0B214A',
    tagline: 'Containerization Fundamentals'
  },
  CUSTOM: {
    fullName: '',
    shortName: 'Custom',
    code: '',
    vendor: 'Grras Solutions',
    color: '#F5A623',
    accent: '#1a1a1a',
    tagline: ''
  }
};

export const COURSE_KEYS = Object.keys(CERTIFICATE_TEMPLATES);
